<template>
  <CForm @submit.prevent="">
    <CRow>
      <CCol sm="12">
        <CInput
          :label="$t('automation.new.form.name')"
          :lazy="false"
          :value.sync="$v.form.name.$model"
          :isValid="checkIfValid('name')"
          @keyup="updateField('name', form.name, FIELD_TYPE.WORKFLOW)"
          :invalidFeedback="invalidFeedbackName"
          :disabled="loading"
          :description="$t('automation.new.form.description')"
        />
      </CCol>
    </CRow>
    <CRow class="mt-2">
      <CCol sm="12">
        <CSelect
          :label="$t('automation.new.form.startingPoint')"
          v-model="$v.form.startingDate.$model"
          :isValid="checkIfValid('startingDate')"
          :invalidFeedback="$t('automation.new.form.validations.feedback.required')"
          @change="updateField('name', form.name, FIELD_TYPE.WORKFLOW)"
          :options="startingPointOptions"
          :disabled="loading || isBirthDate || isLoadingAudienceSchema"
        />
      </CCol>
    </CRow>
    <CRow :gutters="true" class="mt-2" alignVertical="end">
      <CCol sm="7">
        <CSelect
          :label="$t('automation.new.form.whenShouldBeSent')"
          v-model="$v.form.whenShouldBeSent.$model"
          :isValid="checkIfValid('whenShouldBeSent')"
          :invalidFeedback="$t('automation.new.form.validations.feedback.required')"
          :options="whenShouldBeSentOptions"
          :disabled="loading"
          @change="
            updateField('triggerOffsetInMinutes', form.whenShouldBeSent, FIELD_TYPE.TRIGGER, function () {
              let offset = form.days
              // Before date
              if (form.whenShouldBeSent == 1) offset = offset * -1
              // Current Day
              if (form.whenShouldBeSent == 3) offset = 0
              return offset
            })
          "
        />
      </CCol>
      <CCol sm="3">
        <CSelect
          v-if="!isCurrentDateSelected"
          v-model="$v.form.days.$model"
          :isValid="checkIfValid('days')"
          :options="daysOptions"
          :disabled="loading"
          @change="
            updateField('triggerOffsetInMinutes', form.days, FIELD_TYPE.TRIGGER, function () {
              let offset = form.days
              // Before date
              if (form.whenShouldBeSent == 1) offset = offset * -1
              // Current Day
              if (form.whenShouldBeSent == 3) offset = 0
              return offset
            })
          "
        />
      </CCol>
      <CCol sm="2">
        <CRow class="py-4 text-center">
          <CCol v-if="!isCurrentDateSelected">{{ $t('automation.new.form.days') }}</CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow class="mt-2">
      <CCol sm="12">
        <CInput
          :label="$t('automation.new.form.shippingTime')"
          class="mb-1"
          placeholder="00:00"
          type="time"
          :value.sync="$v.form.shippingTime.$model"
          :isValid="checkIfValid('shippingTime')"
          @change="
            updateField('triggerDate', form.shippingTime, FIELD_TYPE.TRIGGER, function () {
              return `1900-01-01T${form.shippingTime}:00.000Z`
            })
          "
          :invalidFeedback="$t('automation.new.form.validations.feedback.required')"
          :disabled="loading"
        />
      </CCol>
    </CRow>
    <CRow class="mt-2">
      <CCol sm="12">
        <CSelect
          :label="$t('automation.new.form.timezone')"
          :options="timezonesOptions"
          v-model="$v.form.timezone.$model"
          :isValid="checkIfValid('timezone')"
          @change="updateField('timezone', form.timezone, FIELD_TYPE.TRIGGER)"
          :invalidFeedback="$t('automation.new.form.validations.feedback.required')"
          :disabled="loading || isLoadingTimezones"
        />
      </CCol>
    </CRow>
  </CForm>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import services from '@/services.js'
import { getItem } from '@/utils/StorageManager'
import { getDateFromISO } from '@/utils/dateUtil'
import { getSchema } from '@/utils/audienceSchema'
import { FIELD_TYPE } from '../constants'

const formatTime = (date) => {
  date = getDateFromISO(date)
  let hours = date.getUTCHours()
  let minutes = date.getUTCMinutes()

  return `${hours >= 10 ? hours : '0' + hours}:${minutes >= 10 ? minutes : '0' + minutes}`
}

const dataTypesEnum = {
  DATE: 'DATE',
}

export default {
  name: 'AutomationForm',
  mixins: [validationMixin],
  props: {
    statingPointList: {
      type: Array,
      default: () => [],
    },
    isBirthDate: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      FIELD_TYPE: FIELD_TYPE,
      isLoadedTimezone: false,
      timezoneLoaded: null,
      isLoadedFieldType: false,
      fieldTypeLoaded: null,
      dateFieldsList: [],
      form: {
        name: null,
        startingDate: null,
        whenShouldBeSent: null,
        days: null,
        shippingTime: '00:00',
        timezone: null,
      },
      startingPointOptions: [],
      whenShouldBeSentOptions: [
        { value: 1, label: this.$t('automation.new.form.daysOptions.beforeDate') },
        { value: 2, label: this.$t('automation.new.form.daysOptions.afterDate') },
        { value: 3, label: this.$t('automation.new.form.daysOptions.currentDate') },
      ],
      // valor em minutos
      daysOptions: [
        { label: '1', value: 1440 },
        { label: '2', value: 2880 },
        { label: '3', value: 4320 },
        { label: '4', value: 5760 },
        { label: '5', value: 7200 },
      ],
      timezonesOptions: [],
      isLoadingAudienceSchema: true,
      isLoadingTimezones: true,
    }
  },
  mounted() {
    this.form.whenShouldBeSent = this.whenShouldBeSentOptions[0].value
    this.form.days = this.daysOptions[0].value

    this.getAudienceSchema()
    this.getTimezones()
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      startingDate: {
        required,
      },
      whenShouldBeSent: {
        required,
      },
      days: {
        required,
      },
      shippingTime: {
        required,
      },
      timezone: {
        required,
      },
    },
  },
  computed: {
    invalidFeedbackName() {
      if (!this.$v.form.name.required) return this.$t('automation.new.form.validations.feedback.required')
      if (!this.$v.form.name.minLength) return this.$t('automation.new.form.validations.feedback.minLength')
      if (!this.$v.form.name.maxLength) return this.$t('automation.new.form.validations.feedback.maxLength')

      return this.$t('automation.new.form.validations.feedback.error')
    },
    isCurrentDateSelected() {
      return this.form.whenShouldBeSent == 3
    },
  },
  methods: {
    updateField(name, value, type = FIELD_TYPE.TRIGGER, formatter) {
      this.$nextTick(() => {
        if (typeof formatter == 'function') {
          value = formatter()
        }

        let obj = {
          property: name,
          value: value,
          type: type,
        }
        this.$emit('update-field', obj)
      })
    },

    loadForm(formData) {
      this.isLoadedTimezone = true // Usado para indicar no final do carregamento da listagem da timezone, que foi carregado o form

      this.form.name = formData.name
      this.fieldTypeLoaded = formData.dateFieldName
      this.form.whenShouldBeSent = formData.triggerOffsetInMinutes < 0 ? 1 : formData.triggerOffsetInMinutes > 0 ? 2 : 3
      this.form.days = formData.triggerOffsetInMinutes < 0 ? formData.triggerOffsetInMinutes * -1 : formData.triggerOffsetInMinutes
      this.form.shippingTime = formatTime(formData.triggerDate)

      this.timezoneLoaded = formData.timezone
    },

    getForm() {
      // let timezoneOffset = this.timezonesOptions.find((elm) => elm.timeZoneId == this.form.timeZone)['triggerOffsetInMinutes']
      let offset = this.form.days
      // Before date
      if (this.form.whenShouldBeSent == 1) offset = offset * -1
      // Current Day
      if (this.form.whenShouldBeSent == 3) offset = 0

      let model = {
        segmentId: null,
        dateFieldName: this.form.startingDate,
        triggerOffsetInMinutes: offset,
        triggerDate: `1900-01-01T${this.form.shippingTime}:00.000Z`, // Na criação não há um campo de indicação para data do trigger
        schedulingTime: new Date(),
        useBirthdateFieldName: this.isBirthDate,
        timezone: this.form.timezone,
      }
      return { name: this.form.name, triggerData: model }
    },
    validateField(fieldName) {
      this.$v.form.name.$touch()
      const field = this.$v[fieldName]
    },
    validateForm() {
      this.$v.form.$touch()
      return !this.$v.form.$invalid
    },
    checkIfValid(fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !field.$invalid
    },
    getTimezones() {
      this.isLoadingTimezones = true
      let currentTimezone = JSON.parse(getItem('user')).timeZone

      services
        .timeZones()
        .then((res) => {
          this.timezonesOptions = res.data.data
            .map((elm) => {
              return {
                label: `${elm.timeZoneDescription} | ${this.$t(`general.components.selects.timeZone.${elm.timeZoneId}`)}`,
                value: elm.timeZoneId,
                triggerOffsetInMinutes: elm.offsetInMinutes,
              }
            })
            .sort((countryA, countryB) => {
              const UTC_A = Number(countryA.label.split(' ')[1].replace('h', ' '))
              const UTC_B = Number(countryB.label.split(' ')[1].replace('h', ' '))

              return UTC_A - UTC_B
            })

          // No caso do form ter sido carregado externamente, a timezone carregada é a que será usada
          if (this.isLoadedTimezone) {
            this.form.timezone = this.timezoneLoaded
            this.isLoadedTimezone = false
            return
          }

          if (currentTimezone) {
            this.form.timezone = this.timezonesOptions.find((elm) => elm.value == currentTimezone)['value']
          }
        })
        .finally(() => {
          this.isLoadingTimezones = false
        })
    },
    filterDateFields(values) {
      return values
        .filter((el) => el.dataType.value == dataTypesEnum.DATE)
        .map((el) => {
          // Adiciona as propriedades necessárias para a listagem
          return {
            key: el.key,
            label: el.value,
            value: el.fieldName,
          }
        })
    },
    async getAudienceSchema() {
      try {
        this.isLoadingAudienceSchema = true
        const organizationId = this.$route.params.organizationId
        let audienceSchema = await getSchema(organizationId)
        this.dateFieldsList = this.filterDateFields(audienceSchema)
        // Atribuição externa, em caso de ser necessário alguma manipulação dos dados do array
        this.startingPointOptions = this.dateFieldsList.map((el) => {
          return {
            value: el.value,
            label: el.label,
          }
        })

        // No caso do form ter sido carregado externamente, o campo carregada é a que será usado
        if (this.isLoadedFieldType) {
          this.form.startingDate = this.timezoneLoaded
          this.isLoadedFieldType = false
          return
        }

        if (this.startingPointOptions && this.startingPointOptions.length > 0) {
          if (this.isBirthDate) {
            this.form.startingDate = this.startingPointOptions.find((el) => el.label == 'BIRTH_DATE')['value']
          } else this.form.startingDate = this.startingPointOptions[0].value
        }
      } finally {
        this.isLoadingAudienceSchema = false
      }
    },
  },
}
</script>
